import { useCustomerHistory } from '@/api/hooks/useCustomers';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Skeleton } from '@/components/ui/skeleton';
import { formatDate, money } from '@/lib/utils';

export function CustomerHistoryDialog({
  phone,
  name,
  onOpenChange,
}: {
  phone: string | null;
  name: string;
  onOpenChange: (open: boolean) => void;
}) {
  const { data, isLoading } = useCustomerHistory(phone);

  return (
    <Dialog open={phone !== null} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{name} — history</DialogTitle>
        </DialogHeader>

        {isLoading ? (
          <div className="space-y-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-20" />
            ))}
          </div>
        ) : (
          <>
            <p className="text-xs text-muted-foreground">
              {data?.sales.length ?? 0} transaction(s)
            </p>

            {!data || data.sales.length === 0 ? (
              <p className="py-6 text-center text-sm text-muted-foreground">No purchase history.</p>
            ) : (
              <div className="max-h-96 space-y-2 overflow-y-auto">
                {data.sales.map((sale) => (
                  <div key={sale.id} className="rounded-md bg-secondary/50 p-3">
                    <div className="flex items-center justify-between">
                      <span className="font-mono text-sm font-semibold">{sale.invoiceNo}</span>
                      <span className="text-xs text-muted-foreground">{formatDate(sale.createdAt)}</span>
                    </div>
                    <p className="mt-1 truncate text-xs text-muted-foreground">
                      {sale.items.map((i) => `${i.medicineName} ×${i.quantity}`).join(', ') || '—'}
                    </p>
                    <div className="mt-1.5 flex items-center justify-between">
                      <Badge variant={sale.isReturn ? 'out' : 'secondary'}>
                        {sale.isReturn ? 'Return' : sale.paymentMode}
                      </Badge>
                      <span className="tabular text-sm font-semibold text-primary">{money(sale.totalAmount)}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}